import React, {useEffect, useState} from 'react';
import SquarePowered from '../../images/square-powered.png';

export async function tokenizePaymentMethod(paymentMethod) {
    const tokenResult = await paymentMethod.tokenize();
    // A list of token statuses can be found here:
    // https://developer.squareup.com/reference/sdks/web/payments/enums/TokenStatus
    if (tokenResult.status === 'OK') {
        return tokenResult.token;
    }
    let errorMessage = `Tokenization failed-status: ${tokenResult.status}`;
    if (tokenResult.errors) {
        errorMessage += ` and errors: ${JSON.stringify(tokenResult.errors)}`;
    }
    throw new Error(errorMessage);
}

function SquareElement({
                           square_application_id,
                           square_location_id,
                           sandbox,
                           setSquarePaymentMethod,
                           setIsValidCard,
                       }) {
    const [loaded, setLoaded] = useState(false);
    const [squarePayments, setSquarePayments] = useState(undefined);
    const [squareCard, setSquareCard] = useState(undefined);
    const [isSubmitting, setSubmitting] = useState(false);
    const [validFields, setValidFields] = useState({
        cardNumber: false,
        cvv: false,
        expirationDate: false,
        postalCode: false,
    });
    const isCardFieldsValid = Object.values(validFields).every((v) => v);

    // Add Square script to the page
    useEffect(() => {
        const existingScript = document.getElementById('webPayment');
        if (existingScript) setLoaded(true);
        else {
            const script = document.createElement('script');
            script.src = `https://${sandbox ? 'sandbox.' : ''}web.squarecdn.com/v1/square.js`;
            script.id = 'webPayment';
            document.body.appendChild(script);
            script.onload = () => {
                setLoaded(true);
            };
        }
    }, []);

    // Instantiate Square payments and store the object in state
    useEffect(() => {
        if (loaded && !squarePayments) {
            if (!window && !window.Square) {
                console.error('Square.js failed to load properly');
                return;
            }
            setSquarePayments(window.Square && window.Square.payments(square_application_id, square_location_id));
        }
    }, [loaded, squarePayments]);

    // Handle the form submission
    const handlePaymentMethodSubmission = async (paymentMethod) => {
        console.log(paymentMethod);
        const isCard = paymentMethod && paymentMethod.element && paymentMethod.element.id === 'card-container';
        if (isCard && !isCardFieldsValid) return;
        if (!isSubmitting) {

            if (isCard) setSubmitting(true);
            try {
                const token = await tokenizePaymentMethod(paymentMethod);
                setSquarePaymentMethod(token);
                setIsValidCard(true);
                console.log('TOKEN', token);
            } catch (error) {
                console.error('FAILURE', error);
                setIsValidCard(false);
            } finally {
                isCard && setSubmitting(false);
            }
        }
    };

    // Set each card field validity on various events
    const handleCardEvents = ({detail}) => {
        if (detail) {
            const {currentState: {isCompletelyValid} = {}, field} = detail;
            if (field) {
                setValidFields((prevState) => ({
                    ...prevState,
                    [field]: isCompletelyValid,
                }));
            }
        }
    };

    // Attach the Square card to our container and setup event listeners
    const attachCard = (card) => {
        // We pass in the card object during initialization, but re-use it from
        // state for normal re-renders
        const cardObject = card || squareCard;
        cardObject.attach('#card-container');
        // Listeners: https://developer.squareup.com/reference/sdks/web/payments/objects/Card#Card.addEventListener
        cardObject.addEventListener('submit', () =>
            handlePaymentMethodSubmission(cardObject),
        );
        cardObject.addEventListener('focusClassAdded', handleCardEvents);
        cardObject.addEventListener('focusClassRemoved', handleCardEvents);
        cardObject.addEventListener('errorClassAdded', handleCardEvents);
        cardObject.addEventListener('errorClassRemoved', handleCardEvents);
        cardObject.addEventListener('cardBrandChanged', handleCardEvents);
        cardObject.addEventListener('postalCodeChanged', handleCardEvents);
    };

    const initializeSquareCard = async () => {
        const card = await squarePayments.card();
        setSquareCard(card);
        attachCard(card);
    };

    useEffect(() => {
        if (squarePayments) {
            if (!squareCard) initializeSquareCard();
        } else {
            if (squareCard) {
                squareCard.destroy();
                setSquareCard(undefined);
            }
        }
    }, [squarePayments]);

    useEffect(() => {
        if (isCardFieldsValid) {
            handlePaymentMethodSubmission(squareCard);
        } else {
            setIsValidCard(false);
        }
    }, [isCardFieldsValid]);

    return (
        <div
            style={{
                display: 'flex',
                flex: 1,
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '2rem',
            }}
        >

            <form id='payment-form'>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <div id='card-container'></div>
                    <div className='w-100 text-right'>
                        <img src={SquarePowered} alt='Square' style={{width: 150}} />
                    </div>
                </div>
            </form>
            <div id='payment-status-container'></div>
        </div>
    );
}

export default SquareElement;



// WEBPACK FOOTER //
// ./src/containers/square/SquareElement.js